import moment from "moment";

export function currencyFormat(num) {
  return Number(num)
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
}

export function stringToNumberFormat(str) {
  let formattedVal;
  if (str.includes(",")) {
    let decimalPart = str.split(",")[1];
    if (decimalPart.length === 1) {
      formattedVal = Number(str.replace(/\.|,/g, "")) / 10;
    } else if (decimalPart.length === 2) {
      formattedVal = Number(str.replace(/\.|,/g, "")) / 100;
    } else {
      formattedVal = Number(str.replace(/\.|,/g, ""));
    }
  } else {
    formattedVal = Number(str.replace(/\.|,/g, ""));
  }
  return formattedVal;
}

export function arrDateToDateObjInLocalTime(arr) {
  const [year, month, day, hour, minute, second] = [
    arr[0],
    arr[1] - 1,
    arr[2],
    arr[3],
    arr[4],
    arr[5]
  ];
  return moment(new Date(Date.UTC(year, month, day, hour, minute, 0)));
}
